import { Typography,Link } from "@material-ui/core";
import React from "react";
import "./Footer.css";


function Footer() {
  return (
    <div style={{marginTop:"5%"}}id="Footer">
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://linkedin.com/in/DrFemzy/">
        Adesokan Emmanuel
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
      </Typography>
      </div>
  );
}

export default Footer;
